var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 5.5888 6.0888 2 10.5 2C12.2816 2 13.9678 2.57318 15.3765 3.6576L13.5174 6.07253C12.6464 5.40206 11.603 5.04762 10.5 5.04762C7.76926 5.04762 5.54762 7.26926 5.54762 10C5.54762 12.7307 7.76926 14.9524 10.5 14.9524C12.6994 14.9524 14.5684 13.5114 15.2125 11.5238H10.5V8.47619H18.5V10C18.5 14.4112 14.9112 18 10.5 18C6.0888 18 2.5 14.4112 2.5 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.72dc11f68492237ea9afeae15572f402.svg";
export { ForwardRef as ReactComponent };